import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'QualidadeRegra';
  const defaultValues = {
    produto_id: null,
    processo_id: null,
    natureza_operacao_id: null,
    qualidade_indicador_id: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset, watch } = useForm({ defaultValues });
  const produto_id = watch('produto_id');

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
      },
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(state?.values?.id) ? 'Editar' : 'Cadastrar') +
          ' Regra de Qualidade'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <VirtualDrop
              name="produto_id"
              label="Produto"
              control={control}
              options={drops?.Produto}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              control={control}
              name="processo_id"
              label="Processo"
              options={drops?.Processo?.filter(
                (f) => f?.produto_id === produto_id
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              control={control}
              name="natureza_operacao_id"
              label="Natureza da Operação"
              options={drops?.NaturezaOperacao}
            />
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              control={control}
              name="qualidade_indicador_id"
              label="Indicador de Qualidade"
              options={drops?.QualidadeIndicador}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
